import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import getSpacingToken from "../common/getSpacingToken";
var StyledSeparator = styled.hr.withConfig({
  displayName: "Separator__StyledSeparator",
  componentId: "sc-8j6gay-0"
})(["width:100%;height:", ";background:", ";box-sizing:border-box;border-style:none;margin-top:0;margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.heightSeparator;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.backgroundSeparator;
}, getSpacingToken);
StyledSeparator.defaultProps = {
  theme: defaultTheme
};

var Separator = function Separator(_ref3) {
  var spaceAfter = _ref3.spaceAfter;
  return React.createElement(StyledSeparator, {
    spaceAfter: spaceAfter
  });
};

export default Separator;